import { SortDescriptor } from "react-aria-components";

import { ExternalIntegration } from "types/generated";

import { SERVICE_NOW_COLUMN_ID } from "./constants";

export const sortServiceNowIntegrations = (
  integrations: ExternalIntegration[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return integrations;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...integrations].sort((a, b) => {
    let valueA: string | undefined;
    let valueB: string | undefined;

    switch (sortDescriptor.column as SERVICE_NOW_COLUMN_ID) {
      case SERVICE_NOW_COLUMN_ID.NAME:
        valueA = a.name;
        valueB = b.name;
        break;
      case SERVICE_NOW_COLUMN_ID.SPACE:
        valueA = a.spaceDetails?.name;
        valueB = b.spaceDetails?.name;
        break;
      case SERVICE_NOW_COLUMN_ID.DESCRIPTION:
      case SERVICE_NOW_COLUMN_ID.DROPDOWN:
        break;
    }

    valueA = valueA || "";
    valueB = valueB || "";

    return isAscending
      ? valueA.localeCompare(valueB, undefined, { numeric: true })
      : valueB.localeCompare(valueA, undefined, { numeric: true });
  });
};
